var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.429,
    height: 12,
    viewBox: "0 0 9.429 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eda0a8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M89.321,37.143h-3.75a1.286,1.286,0,0,1-1.286-1.286v-3.75A.107.107,0,0,0,84.179,32H81.714A1.714,1.714,0,0,0,80,33.714v8.571A1.714,1.714,0,0,0,81.714,44h6a1.714,1.714,0,0,0,1.714-1.714V37.25A.107.107,0,0,0,89.321,37.143Zm-2.464,4.286H82.571a.429.429,0,1,1,0-.857h4.286a.429.429,0,1,1,0,.857Zm0-2.143H82.571a.429.429,0,1,1,0-.857h4.286a.429.429,0,1,1,0,.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M275.943,48.066l-3.852-3.852a.054.054,0,0,0-.091.038v3.477a.429.429,0,0,0,.429.429h3.477a.054.054,0,0,0,.038-.091Z",
    transform: "translate(-186.857 -11.872)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.eee780c413a5257aa7b8bfecaf04de3b.svg";
export { ForwardRef as ReactComponent };